<template>
  <main>
    <div class="container d-flex flex-column">
      <div class="error-detail text-center">
        <span class="error-icon">!</span>
        <p id="err-title" class="error-title">
          {{ $t(error.title) }}
        </p>
        <p id="err-description" class="error-description">
          {{ $t(error.desc) }}
        </p>
        <div @click="$router.back()">
          <span class="volver-caret">
            <span class="caret-left" />
          </span>
          <span class="volver-error">{{ $t("action.back") }}</span>
        </div>
      </div>
    </div>
  </main>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "error-page",
  components: {},
})
export default class ErrorPage extends Vue {
  public type = this.$route.query.type || "";

  constructor() {
    super();
  }

  get error(): { number: string; title: string; desc: string } {
    switch (this.type.toString()) {
      case "401":
      case "403":
        return {
          number: "error403.number",
          title: "error403.title",
          desc: "error403.description",
        };
      case "500":
        return {
          number: "error500.number",
          title: "error500.title",
          desc: "error500.description",
        };
      default:
        return {
          number: "unexpectedError.number",
          title: "unexpectedError.title",
          desc: "unexpectedError.description",
        };
    }
  }
}
</script>

<style lang="scss" scoped>
main {
  height: 70vh;
  width: 100vw;
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}

.error-icon {
  font-size: 50px;
  font-weight: bold;
  color: #efeded;
  background: #212529;
  display: block;
  width: 70px;
  height: 70px;
  border-radius: 100%;
  margin: auto;
  line-height: initial;
}

.error-title {
  margin-top: 1em;
  font-size: 2em;
  font-weight: 400;
}

.error-description {
  font-size: 1.1em;
  font-weight: 400;
}

.volver-caret {
  background-color: #ffd200;
  border-radius: 3px;
  width: 16px;
  height: 16px;
  margin-right: 10px;
  color: #22262e;
  font-size: 16px;
  display: inline-flex;
  vertical-align: text-top;

  .caret-left {
    border-bottom: 5px solid transparent;
    border-top: 5px solid transparent;
    border-right: 5px solid;
    display: inline-block;
    height: 0;
    width: 0;
    margin: auto auto auto 5px;
  }
}

.volver-error {
  display: inline-block;
  color: #22262e;
  font-size: 1.1em;
  line-height: 1em;
  vertical-align: top;

  &:hover {
    text-decoration: underline;
  }
}
</style>
